import { render, staticRenderFns } from "./CategorySelField.vue?vue&type=template&id=507773cc&scoped=true&"
import script from "./CategorySelField.vue?vue&type=script&lang=js&"
export * from "./CategorySelField.vue?vue&type=script&lang=js&"
import style0 from "./CategorySelField.vue?vue&type=style&index=0&id=507773cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507773cc",
  null
  
)

export default component.exports